export enum ColorVariantEnum {
  light = '100',
  default = '400',
  dark = '600',
  darker = '900',
}
